export default class User {
    name;
    Number;
    access;
    password;
    subscription;
    links;
    constructor(n,a,j,e,f) {
        this.name = n;
        this.number = a;
        this.access=j;
        this.password=e;
        // this.subscription=g;
        this.links=f;
    }
}